import { Box, Chip } from "@material-ui/core";
import { FiberManualRecord } from "@material-ui/icons";
import { Grid, styled } from "@mui/material";
import { cloneElement } from "react";

const mapColor = {
  success: "green",
  danger: "red",
  warning: "orange",
  active: "#295ECC",
  default: "gray",
};
const getBackground = (type, customBg) => {
  if (customBg) return customBg;

  switch (type) {
    case "success":
      return "#f0fdf4";
    case "danger":
      return "#fef2f2";
    case "warning":
      return "#fff7ed";
    case "active":
      return "#F0F8FE";
    default:
      return "#f9fafb";
  }
};
const StatusChip = ({
  label,
  type = "default",
  customColorText,
  customColorBackground,
  customBorder,
  startIcon,
  textAlign,
  iconHeight,
  iconWidth,
  isExporting = false,
  ...rest
}) => {
  const iconColor = customColorText || mapColor[type] || mapColor.default;
  const adjustedIcon = startIcon ? (
    cloneElement(startIcon, {
      style: {
        height: iconHeight || 8,
        width: iconWidth || 8,
        color: iconColor,
        ...(startIcon.props?.style || {}),
      },
    })
  ) : (
    <StyledIcon customColor={iconColor} />
  );

  return label ? (
    <Box textAlign={textAlign || "left"} {...rest}>
      {isExporting ? (
        <Box
          p="2px 8px 2px 4px"
          bgcolor={getBackground(type, customColorBackground)}
          borderRadius={16}
          color={iconColor}
          border={`${customBorder?.width ||
            "0.5px"} solid ${customBorder?.color || iconColor}`}
          fontSize={12}
          fontWeight={500}
          width="fit-content"
        >
          <Grid container columnGap={0.5}>
            <Grid item>{adjustedIcon}</Grid>
            <Grid item>{label}</Grid>
          </Grid>
        </Box>
      ) : (
        <StyledChip
          label={label}
          size="small"
          type={type}
          iconColor={iconColor}
          customColorBackground={customColorBackground}
          customBorder={customBorder}
          icon={adjustedIcon}
          {...rest}
        />
      )}
    </Box>
  ) : (
    "-"
  );
};
const StyledChip = styled(Chip)(
  ({ type, iconColor, customColorBackground, customBorder }) => {
    return {
      color: iconColor,
      backgroundColor: getBackground(type, customColorBackground),
      border: `${customBorder?.width || "0.5px"} solid ${customBorder?.color ||
        iconColor}`,
      fontWeight: 500,

      "& .MuiChip-label": {
        color: iconColor,
      },
    };
  }
);

const StyledIcon = styled(FiberManualRecord)(({ customColor }) => ({
  height: 8,
  width: 8,
  color: customColor,
}));

export default StatusChip;
